import { Link } from 'react-router-dom';

const AttachmentPopup = ({
  filesAttached,
  handleClose,
  handleSave,
  handleFileChange,
  handleDelete,
  handleView,
  loading,
}) => {
  return (
    <div id="genricPopup">
      <div className="popup-backdrop">
        <div className="popup">
          {/* Popup Header */}
          <div className="popup-header">
            <h4 className="popup-title">Attach File</h4>
            <button className="custom-btn-close" onClick={handleClose}></button>
          </div>

          {/* Popup Body */}
          <div className="popup-body">
            <div className="dropfile_container">
              <div className="attachment_card">
                <div className="attachment_body">
                  <div className="file-upload">
                    <input
                      className="file-input"
                      type="file"
                      multiple
                      accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.doc,.docx,.xls,.xlsx,.txt,.csv"
                      onChange={handleFileChange}
                    />
                    <div className="card-subtitle">Drag n Drop your file here</div>
                  </div>
                </div>
                <div className="file-list">
                  {filesAttached &&
                    filesAttached.map((file, index) => (
                      <div key={index} className="file-item">
                        <span className="file-name">{file.name}</span>
                        <div className="file-actions">
                          <Link className="view-btn" onClick={() => handleView(file)}>
                            <img
                              src="/assets/images/view.png"
                              className="action-img2"
                              alt="View file"
                              title="View file"
                            />
                          </Link>
                          <Link className="delete-btn" onClick={() => handleDelete(index)}>
                            <img
                              src="/assets/images/trash.png"
                              className="action-img2"
                              alt="Delete file"
                              title="Delete file"
                            />
                          </Link>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>

          {/* Popup Footer */}
          <div className="popup-footer">
            <button type="button" className="btn btn-primary" onClick={handleClose}>
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSave}
              disabled={filesAttached.length === 0}
            >
              {loading && (
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
              )}
              {loading ? 'Loading...' : 'Attach'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AttachmentPopup;
